/** Stable portfolio account id for Mongo Trends (same id across days). */
export function createPortfolioAccountId(): string {
  const rand = Math.random().toString(36).slice(2, 10);
  return `pa_${Date.now().toString(36)}_${rand}`;
}
